import styled from 'styled-components'
export { Modal, Button, Typography } from '@tmov/design-system'

export const Content = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: flex-end;
  p {
    width: 100%;
  }
`
